import React from 'react';
import { ExternalLink } from 'lucide-react';
import { FieldDisplayProps } from '../../types';

export const UrlFieldDisplay: React.FC<FieldDisplayProps> = ({
  value,
  onStartEditing,
  isReadOnly,
}) => {
  const handleClick = () => {
    if (!isReadOnly) {
      onStartEditing();
    }
  };

  if (!value) {
    return (
      <div
        className="pill custom-field-pill editable empty-placeholder"
        onClick={handleClick}
      />
    );
  }

  const href = value.startsWith('http') ? value : `https://${value}`;

  return (
    <div
      className="url-cell editable"
      onClick={handleClick}
      onDoubleClick={handleClick}
      title={value}
    >
      <ExternalLink size={14} className="url-icon" />
      <span className="url-text">{value}</span>
    </div>
  );
};

export default UrlFieldDisplay;
